<template>
	<div>
		<a-popover :visible="visible_bold" trigger="click" placement="left"  :destroyTooltipOnHide="true"
		@visibleChange="moreEvent()"
		:getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
		  <template slot="content">
			  <div>
				  <div class='warp-title'>詳 情</div>
				  <div class='langtop'>
					  <div class='nonebor'>
					  		<div @click='england = "cn"' :style='england == "cn"?"color:#0c8b96":""'>中文</div>
					  		<div @click='england = "en"' :style='england == "en"?"color:#0c8b96":""' style="border-left: 1px solid #999;margin-right: .3rem;">EN</div>
					  </div></div>
				  <div class='warp_body'  :class="england == 'en'?'langen':''">
			<a-form-model :model="formview" layout="inline" id='view_sub' :rules='rules'>
				<div :class='viewpaif>0&&!formview.cn_planned_company_name_cn&&formview.status_cn < 3?"warp_red":""' v-if='england=="cn"'>
					<a-form-model-item :label="lang.comname">
						<a-input v-model="formview.cn_planned_company_name_cn" auto-complate='on' :read-only='disabled' @input="checkForm('cn_name')"/>
					</a-form-model-item>
				</div>
				<div :class='viewpaif>0&&!formview.cn_planned_company_name_en&&formview.status_cn < 3?"warp_red":""' v-else>
					<a-form-model-item :label="lang.comname">
						<a-input v-model="formview.cn_planned_company_name_en" auto-complate='on' :read-only='disabled' @input="checkForm('cn_name')"/>
					</a-form-model-item>
				</div>
				<div :class='viewpaif>0&&!formview.cn_planned_industry_name_cn&&formview.status_cn < 3?"warp_red":""'  v-show='england=="cn"'>
					<a-form-model-item :label="lang.nature">
						<!-- <a-select v-model="formview.cn_planned_industry_name_cn" :disabled='disabled'>
							<a-select-option v-for="(item) in khtypeArrs" :key="item.key + 'd'" :value="item.value">
								{{item.text}}
							</a-select-option>
						</a-select> -->
						<Situationall v-model="formview.cn_planned_industry_name_cn" v-if='england=="cn"'
									  :url='$api.getParamList'
									  :params='{"type":"industrys","cn_planned_industry_name_en":formview.cn_planned_industry_name_en}'
									  :style='"width:18rem"'
									  :valonce='JSON.parse(JSON.stringify(formview)).cn_planned_industry_name_cn'
									  ></Situationall>
									  <!-- :placeholder="'請選擇上市行業'" -->
						<!-- <a-input v-model="formview.cn_planned_industry_name_cn" placeholder="請輸入上市行業" /> -->
					</a-form-model-item>
				</div>
				<div :class='viewpaif>0&&!formview.cn_planned_industry_name_en&&formview.status_cn < 3?"warp_red":""'  v-show='england=="en"'>
					<a-form-model-item :label="lang.nature">
						<Situationall v-model="formview.cn_planned_industry_name_en" v-if='england=="en"'
									  :url='$api.getParamList'
									  :params='{"type":"industrys","cn_planned_industry_name_cn":formview.cn_planned_industry_name_cn}'
									  :style='"width:18rem"'
									  :valonce='JSON.parse(JSON.stringify(formview)).cn_planned_industry_name_en'
									  ></Situationall>
									  <!-- :placeholder="'請選擇上市行業'" -->
					</a-form-model-item>
				</div>
				<div :class='viewpaif>0&&formview.plates_cn<0&&formview.status_cn < 3?"warp_red":""'>
					<a-form-model-item :label="lang.market">
						<a-select v-model="formview.plates_cn" :disabled='disabled'>
							<a-select-option v-for="(item) in admintypeArrs" :key="item.key + 'a'"
								:value="item.value">{{england=="cn" ?item.text : item.entext}}</a-select-option>
						</a-select>
					</a-form-model-item>
				</div>
				<div :class='viewpaif>0&&!formview.status_cn?"warp_red":""'>
					<a-form-model-item :label="lang.status">
						<a-select v-model="formview.status_cn" :disabled='disabled'
							@change='handselefn(formview.status_cn,"formview")'>
							<a-select-option v-for="(item,ind) in admintypeArr" :key="item.key + 'b'"
								 :value="item.value">{{england=="cn" ?item.text : item.entext}}</a-select-option>
						</a-select>
					</a-form-model-item>
				</div>
				<div :class='viewpaif>0&&!formview.delivery_date&&formview.status_cn < 3?"warp_red":""'>
					<a-form-model-item :label="lang.subdata">
						<a-date-picker v-model="formview.delivery_date" @change="handback('delivery_date')" :disabled='disabled'
							:disabled-date="deliveryDate" placeholder=" "/>
							<!-- 请输入遞表日期 -->
					</a-form-model-item>
				</div>
				<div style="overflow: hidden;">
					<a-form-model-item :label="lang.profile" prop='info' class='lgohe'>
						<a-textarea v-model="formview.info" :auto-size="{ minRows: 4, maxRows: 4 }" :maxLength='200'  :disabled='disabled' 
							:disabled-date="deliveryDate" placeholder=" " class='warp_width' />
							<!-- 请输入公司業務 -->
							<!-- <span style="color:#bfbfbf;position:absolute;bottom:-10px;right:10px;">{{formview.info.length}}/200</span> -->
					</a-form-model-item>
				</div>
				<div :class='viewpaif>0&&!formview.stockname&&formview.status_cn > 0?"warp_red":""'  v-if='england=="cn"'>
					<a-form-model-item :label="lang.stockname">
						<a-input v-model="formview.stockname" auto-complate='on' :read-only='disabled'/>
					</a-form-model-item>
				</div>
				<div :class='viewpaif>0&&!formview.stockname_en&&formview.status_cn > 0?"warp_red":""'  v-if='england=="en"'>
					<a-form-model-item :label="lang.stockname">
						<a-input v-model="formview.stockname_en" auto-complate='on' :read-only='disabled'/>
					</a-form-model-item>
				</div>
				<div :class='viewpaif>0&&!formview.stockcode&&formview.status_cn > 0?"warp_red":""'>
					<a-form-model-item :label="lang.stockcode">
						<a-input v-model="formview.stockcode" auto-complate='on' :read-only='disabled' @blur='stockcodeFn("stockcode")' :maxLength='5' />
					</a-form-model-item>
				</div>
				<div :class='viewpaif>0&&!formview.baojianr&&statered == 2?"warp_red":""' style="overflow: hidden;">
					<a-form-model-item :label="lang.sponsor"  class='lgohe1'>
						<!-- <a-select v-model="formview.baojianr" placeholder="please select your zone"
							:disabled='disabled'>
							<a-select-option v-for="(item) in khtypeArrbj" :key="item.key + 'c'"
								:value="item.value">{{item.text}}</a-select-option>
						</a-select> -->
						<!-- <Situationall v-model="formview.baojianr"
									  :url='$api.getParamList'
									  :params='{"type":"baojianr"}'
									  :style='"width:18rem"'
									  :val='.baojianr'
									  :placeholder="'多個保薦機構請用分號分隔'"></Situationall> -->
					 <!-- <a-input v-model="formview.baojianr" placeholder="請輸入保衛脊膘" /> -->
					 <a-textarea v-model="formview.baojianr" :auto-size="{ minRows: 3, maxRows: 3 }" :maxLength='200' @input="baofn"
					 	:disabled='disabled'  :disabled-date="deliveryDate" :placeholder="lang.cname" class='warp_width' />
					</a-form-model-item>
				</div>
				<div :class='viewpaif>0&&!formview.listingdate&&statered == 2?"warp_red":""'>
					<a-form-model-item :label='lang.ldata'>
						<a-date-picker v-model="formview.listingdate" type="date" @change="handback('listingdate')"
							:disabled-date="disabledDate" placeholder=" " :disabled='disabled'/>
							<!-- 请输入上市日期 -->
					</a-form-model-item>
				</div>
				<div :class='viewpaif>0&&!formview.entryfee&&statered == 2?"warp_red":""'>
					<a-form-model-item :label="lang.efee">
						<a-input v-model="formview.entryfee" auto-complate='on' :read-only='disabled' @blur='stockcodeFn("entryfee",1)'/>
					</a-form-model-item>
				</div>
				<div :class='viewpaif>0&&!formview.pergshu&&statered == 2?"warp_red":""'>
					<a-form-model-item :label="lang.Board">
						<a-input v-model="formview.pergshu" auto-complate='on' :read-only='disabled' @blur='stockcodeFn("pergshu")'/>
					</a-form-model-item>
				</div>
				<div class='val-lil'>
					<div :class='viewpaif>0&&!formview.offer_price_l&&statered == 2?"warp_red":""' class='warp-t'>
						<a-form-model-item :label="lang.price ">
							<a-input v-model="formview.offer_price_l" auto-complate='on' :read-only='disabled' @blur='stockcodeFn("offer_price_l",1)'/>
							<!-- <div style="width: 30px;text-align: center;margin: 0;display: inline-block;">~</div>
							<a-input v-model="formview.offer_price_h" style='width: 20%;'  :read-only='disabled'/> -->
						</a-form-model-item>
					</div>
					<div class='warp-f'>
							<div  :class='viewpaif>0&&!formview.offer_price_h&&statered == 2?"warp_red":""'
							style="padding: 7px 0px 10px;background-color: #f0f2f5;display: inline-block;width: 2.2rem;text-align: center;">~</div>
						<!-- 	<a-input v-model="formview.offer_price_l" auto-complate='on' :read-only='disabled' />
							<div style="width: 30px;text-align: center;margin: 0;display: inline-block;">~</div> -->
							<a-input v-model="formview.offer_price_h" :read-only='disabled' @blur='stockcodeFn("offer_price_h",1)'/>
					</div>
				</div>
				<div class='val-lil'>
				<div :class='viewpaif>0&&!formview.application_open&&statered == 2?"warp_red":""' class='warp-two warp-t'>
					<a-form-model-item :label="lang.Period">
						<a-date-picker  :disabled='disabled' v-model='formview.application_open' 
						placeholder=" " :disabled-date="disabledDate" @change="handback('application_open')">
							<template slot="dateRender" slot-scope="current, today">
								<div class="ant-calendar-date" :style="getCurrentStyle(current, today)">
									{{ current.date() }}
								</div>
							</template>
						</a-date-picker>
						<!-- 啟示認購日期 -->
					</a-form-model-item></div>
					<div class='warp-f'>
						<div :class='viewpaif>0&&!formview.application_close&&statered == 2?"warp_red":""'
						style="padding: 7px 0px 10px;background-color: #f0f2f5;display: inline-block;width: 2.2rem;text-align: center;">~</div>
						<a-date-picker  :disabled='disabled' v-model='formview.application_close' placeholder=" "
							:disabled-date="applicationDate" @change="handback('application_close')">
							<template slot="dateRender" slot-scope="current, today">
								<div class="ant-calendar-date" :style="getCurrentStyle(current, today)">
									{{ current.date() }}
								</div>
							</template>
						</a-date-picker>
						<!-- 終止認購日期 -->
					</div>
				
				</div>
				<div :class='viewpaif>0&&!formview.anpantime&&statered == 2?"warp_red":""'>
					<a-form-model-item :label="lang.grey">
						<a-date-picker v-model="formview.anpantime" type="date" @change="handback('anpantime')"
							  placeholder=" " :disabled-date="deliveryDate"/>
							  <!-- :disabled='formview.anpantime?true:false' -->
							 <!-- 请输入暗盤日期 -->
					</a-form-model-item>
				</div>
				<div :class='viewpaif>0&&!formview.multiple&&statered == 2?"warp_red":""'>
					<a-form-model-item :label="lang.rate">
						<a-input v-model="formview.multiple" auto-complate='on' :read-only='disabled' @blur='stockcodeFn("multiple")'/>
					</a-form-model-item>
				</div>
				<div :class='viewpaif>0&&!formview.linkaddress?"warp_red":""'>
					<a-form-model-item :label="lang.Prospectus">
						<a-input v-model="formview.linkaddress" auto-complate='on' :read-only='disabled'/>
					</a-form-model-item>
				</div>
			</a-form-model>
			<div class='warp-bottom'>
				<a-button  v-if='!disabled' class="tableBzViewBtn" style="background-color:#e8e8e8;" @click='visible_bold = false'>{{lang.cancel}}
				</a-button>
				<a-button  v-if='!disabled' class="tableBzViewBtn" style="background-color:#3bc7a1;margin-left: 120px;" @click='imfrom()'>{{lang.save}}
				</a-button>
			<!-- 	 <a-button class="tableBzViewBtn" @click='$emit("child",false)'>取消</a-button>
				<a-button  class="tableBzViewBtn" style="margin-left: 110px;color: #fff;" type="primary" @click='imfrom()'>
				      保存
				    </a-button> -->
					<br>
			</div>
			</div></div></template>
		<img :src="visible_bold ? icon_pdf1 : icon_pdf"
			class="imageC">
		</a-popover>
	</div>
</template>

<script>
	import moment from 'moment';
	import App from '@/assets/app.js';
	import icon_pdf from '@/image/icon_xiangqing.png';
	import icon_pdf1 from '@/image/icon_xiangqing_1.png';
	export default{
		props:['record','ipoAdmin','missionflag'],
		data(){
			return{
				england:'cn',
				visible_bold:false,
				icon_pdf,
				icon_pdf1,
				lang:{},
				formview: {
					anpantime: "",
					application_close: "",
					application_open: "",
					baojianr: "",
					cn_planned_company_name_cn: "",
					cn_planned_industry_name_cn: "",
					delivery_date: "",
					entryfee: "",
					iposelling_id: '',
					listingdate: "",
					multiple: "",
					offer_price_h: "",
					offer_price_l: "",
					pergshu: "",
					plates_cn: "",
					status_cn: "",
					stockcode: "",
					stockname: "",
					info:''
				},
				disabled: false,
				viewpaif:0,
				admintypeArrs: [{
						text: '主板',
						entext:'Mainboard',
						value: 0
					},
					{
						text: '創業板',
						entext:'GEM board',
						value: 1
					},
				],
				admintypeArr: [{
									text: '處理中',
										entext:'Processing',
										value: '0'
									},
									{
										text: '認購中',
										entext:'Subscribing',
										value: '1'
									},
									{
										text: '待上市',
										entext:'Planned IPO',
										value: '2'
									},
									{
										text: '已上市',
										entext:'Listed IPO',
										value: '3'
									},
									{
									   text: '已除牌',
										entext:'Delisted',
										value: '4'
									},
									{
									    text: '已失效',
										entext:'Expired',
										value: '5'
									}	
									],
				zerorules: {
					cn_planned_company_name_cn: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					cn_planned_industry_name_cn: [{
						required: true,
						message: '123',
						trigger: 'change'
					}],
					plates_cn: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					status_cn: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					delivery_date: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
				},
				allrules: {
					stockcode: [{
						required: true,
						message: ' ',
						trigger: ['blur', 'change']
					}],
					stockname: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					offer_price_l: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					offer_price_h: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					pergshu: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					application_open: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					application_close: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					listingdate: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					entryfee: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					cn_planned_industry_name_cn: [{
						required: true,
						message: '123',
						trigger: 'change'
					}],
					cn_planned_company_name_cn: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					status_cn: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					plates_cn: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					delivery_date: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					baojianr: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					anpantime: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					multiple: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
				},
				rules: {},
				statered:'',
				stockrules: {
					stockcode: [{
						required: true,
						message: ' ',
						trigger: ['blur', 'change']
					}],
					stockname: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
				},
			}
		},
		created() {},
		watch:{
			england:{
				immediate: true,
				handler (ev){
					this.lang = this.england=='cn'?this.$big5.sub:this.$eng.sub
				},
			},
			// formview: {
			// 	deep:true,
			// 	immediate: true,
			// 	handler (ev){
			// 		console.log(ev,this.formview.plates_cn)
			// 	}
			// }
		},
		mounted(){
			this.disabled = !this.ipoAdmin
			// this.handselefn(this.formview.status_cn)
		},
		methods: {
			baofn(){
				this.formview.baojianr = this.formview.baojianr.replace(/[,]+/g, '')
			},
			//禁止選擇
			deliveryDate(current){
				return current && current > new Date(this.formview.listingdate)
			},
			//禁止選擇(小于=)
			disabledDate(current){
				return current && current < new Date(this.getNextDate(this.formview.delivery_date,1)) 
			},
			//禁止選擇(大于=)
			applicationDate(current){
				return current && current > new Date(this.formview.anpantime)
			},
			stockcodeFn(value,zero){
				this.formview[value] = App.isnumdate(this.formview[value] ,zero)
			},
			handselefn(val,ruleForm){
				if (val == 0) {
					this.statered = 1
					this.rules = this.zerorules
				} else if (val == 1 || val == 2) {
					this.rules = this.allrules
					this.statered = 2
				} else if (val == 3) {
					this.statered = 3
					this.rules = this.stockrules
				}
				/* let obj = JSON.parse(JSON.stringify(this.form))
				this.$refs[ruleForm].resetFields();
				this.formview = obj */
			},
			handback(val) {
				this.formview[val] = this.formview[val] ? App.oDate.secsTime3(this.formview[val]._d) : ''
				//（遞表日期）》啟示認購日期 》 終止認購日期》（上市日期）
				//啟示認購日期 》 終止認購日期》
				if (val == 'application_close' || val == 'application_open') {
					if (this.formview.application_close && this.formview.application_open) {
						this.compareDate('application_open', 'application_close')
					}
				}
				//遞表日期》上市日期
				if (val == 'delivery_date' || val == 'listingdate') {
					if (this.formview.delivery_date && this.formview.listingdate) {
					  this.compareDate('delivery_date', 'listingdate')
						// anpantime
					}
				} 
				//（遞表日期）》啟示認購日期
				if (val == 'delivery_date' || val == 'application_open') {
					if (this.formview.delivery_date && this.formview.application_open) {
						this.compareDate('delivery_date', 'application_open')
					}
				}
				//終止認購日期》（上市日期）
				if (val == 'application_close' || val == 'listingdate') {
					if (this.formview.application_close && this.formview.listingdate) {
						this.compareDate('application_close', 'listingdate')
					}
				}
				
				
				//暗盤日期 獲取上市日期前一天
				if(this.formview.listingdate){
					// this.formview.anpantime = this.getNextDate(this.formview.listingdate,-1)
				}
				//暗盤日期》（上市日期）
				if (val == 'anpantime' || val == 'application_close') {
					if (this.formview.anpantime && this.formview.application_close) {
						this.compareDate('application_close', 'anpantime')
					}
				}
				if (val == 'anpantime' || val == 'delivery_date') {
					if (this.formview.anpantime && this.formview.delivery_date) {
						this.compareDate('delivery_date', 'anpantime')
					}
				}
			},
			 getNextDate(date,day) {
			  var dd = new Date(date);
			  dd.setDate(dd.getDate() + day);
			  var y = dd.getFullYear();
			  var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
			  var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
			  return y + "-" + m + "-" + d;
			},
			compareDate(dateTime1, dateTime2) {
				var formatDate1 = new Date(this.formview[dateTime1])
				var formatDate2 = new Date(this.formview[dateTime2])
				if (formatDate1 > formatDate2) {
					this.formview[dateTime1] = '';
				}
			},
			getCurrentStyle(current, today) {
				const style = {};
				if (current.date() === 1) {
					style.border = '1px solid #1890ff';
					style.borderRadius = '50%';
				}
				return style;
			},
			moreEvent() {
				if(this.visible_bold){
					this.visible_bold = !this.visible_bold
				}else{
					this.handimg()
					this.disabledDate()
				}
			},
			checkForm(data) {
				// if (data == 'en_name') {
				// 	this.formview.en_name = this.formview.en_name.replace(/[^A-Za-z|\s*]+/g, "").replace(/\s+/g, " ").replace(/(^\s*)/g,
				// 		'');
				// } else if (data == 'cn_name') {
				// 	this.formview.cn_name = this.formview.cn_name.replace(/[^\u4e00-\u9fa5]+/g, '').replace(/(^\s*)/g, '');
				// }else{
				// 	this.formview.id_number = this.formview.id_number.replace(/[^A-Za-z|0-9\s*]+/g, "").replace(/\s+/g, " ").replace(/(^\s*)/g,
				// 		'');
				// }
			},
			handimg(record) {
				this.$ajax({
					method: 'post',
					url: this.$api.getIpoSellingById,
					headers: {
						token: this.$store.state.token
					},
					data: {
						"iposelling_id": this.record.iposelling_id,
						missionflag:this.missionflag
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.formview = res.data.iposelling
						if(this.formview.status_cn == 0){
							this.statered = 1
						}else if(this.formview.status_cn == 3){
							this.statered = 3
						}else if(this.formview.status_cn){
							this.statered = 2
						}
						setTimeout(()=>{
							this.visible_bold = true;
						},100)
					}else{
						this.visible_bold = true
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			imfrom() {
				this.viewpaif++
				this.formview.token = ''
				this.formview.token = this.$store.state.token
				let statem = 0
				for(let key in this.rules){
					if(key == 'plates_cn'&& this.formview[key]>=0){
						statem = 0
					}else if(!this.formview[key]){
						statem = 1
					}
				}
				if(statem){
					return
				}
				if (!this.formview.linkaddress) {
					this.$message.error('請填招股書');
					return
				}
				if (this.formview.status_cn < 3) {
					if (!this.formview.cn_planned_company_name_en || !this.formview.cn_planned_industry_name_en) {
						this.$message.error('請填寫英文數據');
						return
					}
				}
				if (this.formview.status_cn == 3||this.formview.status_cn == 1){
					if (!this.formview.stockname_en) {
						this.$message.error('請填寫英文股票名称');
						return
					}
				}
				this.formview.missionflag = this.missionflag
				
				this.$ajax({
					method: 'post',
					url: this.$api.putuse,
					headers: {
						token: this.$store.state.token
					},
					data: this.formview
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						App.oTool.successT();
						this.$emit('child',true);
						this.visible_bold = false;
					}else{
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			}
		}
	}
</script>

<style lang='scss'>
	.warp-bottom{
		 padding: 10px 0;
		 text-align: center;
		 .ant-btn {
		 	border: none !important;
		 	outline: none !important;
			color: #fff;
		 	&:hover {
		 		border: none;
		 		border-color: none;
		 	}
		 
		 	&:focus {
		 		border: none;
		 		border-color: none;
		 		box-shadow: 0 0 0 0 #fff !important;
		 	}
		 }
	}
	.warp_body{
		margin: 10px;
	}
	.nonebor{
		text-align: right;
		div{
			display: inline-block;
			padding: 0 6px;
			cursor: pointer;
		}
	}
	.langtop{
		position: absolute;
		    top: 1rem;
		    right: .5rem;
	}
	.warp-title{
		background-color: #f1f1f1;
		height: 2.2rem;
		text-align: center;
		line-height:2.2rem;
		font-size: .9rem;
		font-weight: bold;
		letter-spacing: 1rem !important;
		
	}
	#view_sub {
		
		 .ant-form-item {
		    margin-right: 0 !important;
		}
		.ant-select-enabled, .ant-input{
				width: 18rem;
		}
		.ant-select-enabled>div{
			border: none;
		}
		/***/
		.ant-select-disabled, .ant-input{
				width: 18rem;
		}
		.ant-input[disabled] {
		    background-color: #fff;
			color: #000;
		}
		.ant-select-disabled .ant-select-selection {
		    background: #fff;
		}
		.ant-select-disabled>div{
			border: none;
		}
		/***/
		    background-color: #fff;
		.warp_red {
			color: red;
			label {
				color: red;
			}
		}
		.ant-form-item-control-wrapper{
			/* width: 100%;
			background-color: #fff; */
		}
		.ant-form-item-label > label{
			display:inline-block;
			width: 5rem !important;
			text-align: center;
			background-color: #f0f2f5;
			font-size: 0.75rem !important;
		}
		
		.tableBzViewBtn {
			margin: 0 0.5rem;
			outline: none;
			color: #fff;
		}

		.ant-input {
			border: none;
			outline: none;

			&:hover {
				border: none;
			}

			&:focus {
				border: none;
				box-shadow: 0 0 0 0 #fff !important;
			}
		}
		.val-lil>div{
			
			display: inline-block;
			vertical-align: top;
			
			 .ant-input{
					width: 7.9rem;
			}
		}
		.val-lil{
			.warp-t{
				width: 56%;
			}
			.warp-f{
				width: 44%;
			}
		}
		
	}

	#view_sub>div {
		border: 1px solid #f3f3f3;
		border-top: none;
	}
	#view_sub>div:first-child {
		border: 1px solid #f3f3f3;
		border-radius: 4px 4px 0 0;
	}
	#view_sub>div:last-child {
		border: 1px solid #f3f3f3;
		border-radius: 0 0 4px 4px;
		border-top: none;
		.ant-input {
			margin: 1px;
		}
	}

	#view_sub>div {
		padding-left: 0px;
	}
	.lgohe{
		.ant-form-item-label{
			height: 5.3rem !important;
			background-color: #f0f2f5;
		}
	}
	.lgohe1{
		.ant-form-item-label{
			height: 4.1rem !important;
			background-color: #f0f2f5;
		}
	}
	.langen{
		#view_sub{
			.ant-form-item-label > label{
					font-size: 0.55rem !important;
				    width: 5.9rem !important;
				    padding-left:  3px !important;
			}
			
			.ant-input {
				font-size: 0.55rem !important;
			}
			.ant-select {
			    font-size: 0.55rem !important;
			}
			.ant-select-dropdown-menu-item {
			    font-size: 0.55rem !important;
			}
			
			.val-lil > div .ant-input {
			    width: 7rem !important;
			}
			
			.val-lil > div:last-child  .ant-input{
			    width: 8.3rem !important;
			}
			
		}
	}
</style>

